import React from 'react';
import Dialog from '@mui/material/Dialog';
import { Form, Formik, FormikProps } from 'formik';
import { object, string } from 'yup';
import FranchiseFilterDialog from './FranchiseFilterDialog';
import {
  setDateFilter
} from "src/redux/slices/FranchiseSlice";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import moment from 'moment';
type Props = {
  onClose: () => void;
};
export type FilterDialogWrapperValues = {
  startDate: any,
  endDate: any
}

const FranchiseFilterDialogWrapper = ({ onClose }: Props) => {
  const dispatch = useDispatch()
  const ticketState = useSelector((state: RootState) => state.franchise);
  const { dateFilter } =
    ticketState;
  // Form Initial Values
  const initialValues: FilterDialogWrapperValues = {
    startDate: dateFilter.start_date || '',
    endDate: dateFilter.end_date || ''
  };

  // Validation Schema
  const validationSchema = object().shape({
    startDate: string().required("please select start date"),
    endDate: string().required("please select end date"),
  });

  // Handle Submit
  const handleSubmit = (
    values: FilterDialogWrapperValues,
  ) => {
    // created date from to dispatch
    dispatch(
      setDateFilter({
        start_date: values.startDate
          ? moment(values.startDate)?.format("yyyy-MM-DD")
          : "",
        end_date: values.endDate
          ? moment(values.endDate)?.format("yyyy-MM-DD")
          : "",
      })
    );
    onClose();
  };

  const handleReset = async (formikProps: FormikProps<FilterDialogWrapperValues>) => {
    // created date filter dispatch
    await dispatch(
      setDateFilter({
        startDate: "",
        endDate: "",
      })
    );
    formikProps.resetForm() 

  }
  return (
    <Dialog open maxWidth='xs' fullWidth>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (

          <Form>
            <FranchiseFilterDialog formikProps={formikProps} onClose={onClose} onReset={() =>{ 
          
               handleReset(formikProps)}} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default FranchiseFilterDialogWrapper;